import axios from "axios";
import { DFTLNGCODE, VENDORID } from "../constants";
import { CONFIG } from "../config";

//get setting
export async function getCustomerCode(email, password) {
    var request = await axios.post(CONFIG.URL, {
        serviceId: '1116',
        vendorId: VENDORID,
        "userEmail": email,
        "password": password,
        "lang": localStorage.getItem('rcml-lang') ?? DFTLNGCODE
    });
    return request.data;
}
